import { type PropsWithChildren } from "react";

import { cn } from "~/lib/utils";

import { Button, type ButtonProps } from "../Button";

type ErrorDisplayProps = PropsWithChildren & {
  className?: string;
};

export const ErrorDisplay = ({ children, className }: ErrorDisplayProps) => {
  return (
    <div
      className={cn(
        "flex h-full flex-col items-center justify-center gap-4 text-center",
        className
      )}
    >
      <img
        src="/images/pos-kitchen-chef.svg"
        alt="POS Chef"
        className="h-auto w-full max-w-72"
      />
      {children}
    </div>
  );
};

const ErrorTitle = ({ children }: PropsWithChildren) => {
  return (
    <p className="text-5xl font-extrabold text-interface-neutral-6">
      {children}
    </p>
  );
};

ErrorDisplay.Title = ErrorTitle;

type ErrorDescriptionProps = PropsWithChildren<{ className?: string }>;

const ErrorDescription = ({ children, className }: ErrorDescriptionProps) => {
  return (
    <p
      className={cn(
        "whitespace-pre-line text-2xl font-semibold text-interface-neutral-6",
        className
      )}
    >
      {children}
    </p>
  );
};

ErrorDisplay.Description = ErrorDescription;

const ErrorAction = ({ children, ...props }: ButtonProps) => {
  return (
    <Button size="medium" {...props} className="min-w-52 rounded-full">
      {children}
    </Button>
  );
};

ErrorDisplay.Action = ErrorAction;
